module.exports = __webpack_public_path__ + "img/1x3.a7dbc6fd.png";